import { BadgeCheck, ShieldCheck, Coins, Scale, RefreshCcw, Gem, Crown, PenTool, HeartHandshake, Users } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { WHY_US } from "../data/content";

const ICONS = { BadgeCheck, ShieldCheck, Coins, Scale, RefreshCcw, Gem, Crown, PenTool, HeartHandshake, Users };

export const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="py-20 md:py-32 bg-royal-deep relative grain overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <SectionHeading
        chapter="02"
        overline="Why Choose Us"
        title="The Promise Behind Every Piece"
        description="Ten commitments that have made Jeweller Kalika Prasad a name families in Howrah return to, generation after generation."
        dark
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-gold/15 border border-gold/15">
        {WHY_US.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <Reveal key={item.title} delay={0.05 * (i % 5)} className="h-full">
              <div
                data-testid={`why-us-card-${i}`}
                className="group h-full bg-royal-deep hover:bg-royal p-7 md:p-8 transition-colors duration-500"
              >
                <Icon size={26} strokeWidth={1} className="text-gold mb-5 transition-transform duration-500 group-hover:-translate-y-1" />
                <h3 className="font-serif text-xl text-ivory leading-snug">{item.title}</h3>
                <p className="mt-2.5 text-sm font-light text-ivory/60 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
